export default "//static.tradera.net/touchweb/static/output/images/network-tt.46cea493.svg";